/* eslint no-console: ["error", { allow: ["info", "debug", "error"] }] */
export const logger = {
  log: console.info,
  debug: console.debug,
  error: console.error
};
